import React, { Fragment, useContext, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import TooltipMenu from "../../../../../../components/ui/tooltipmenu/TooltipMenu";

import OrderTracker from "../../../../../../features/orderTracker";
import AuthContext from "../../../../../../store/context/auth-context";
import { uiActions } from "../../../../../../store/redux/ui/ui-slice";

import classes from "./SubHeaderList.module.css";
import { RESET_APP } from "../../../../../../store/redux/rootActions";
import { CountrySelector } from "../../../../../../components/ui/countrySelector/countrySelector";

const SubHeaderList = () => {
  const [isaccShow, setAccIsShow] = useState();
  const [istrackShow, setTrackIsShow] = useState();
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const isLoggedIn = authCtx.isLoggedIn;
  //const loggedInUsername = (authCtx.userData?.username === 'undefined')?'':authCtx.userData?.username;
  const loggedInUsername = authCtx.userData ? authCtx.userData.username : "";
  // console.table(authCtx.userData);
  const dispatch = useDispatch();
  // const isLoggedIn = useSelector((state) => state.auth.isloggedIn);
  // const isToken = useSelector((state) => state.auth.token);
  // const userName = useSelector((state) => state.auth.userName);

  // useEffect(() => {
  //   if (isToken) {
  //     dispatch(authAction.useIsLoggedIn(isToken));
  //   }
  // }, [isToken, dispatch]);
  //console.log('-----------sub header-----------');
  //console.log(authCtx.userData);

  const logoutHandler = () => {
    // dispatch(authAction.logout());

    dispatch({ type: RESET_APP });

    authCtx.logout();
    dispatch(uiActions.CloseAuthPop());
 

    setTimeout(() => {
   window.location.replace("/");
  }, 50);
  };
  const toggleAccHandler = () => {
    setAccIsShow((prev) => !prev);
    setTrackIsShow(false);
  };
  const toggleTrackHandler = () => {
    setTrackIsShow((prev) => !prev);
    setAccIsShow(false);
  };

  return (
    <Fragment>
      {/* <li>
        <Link to={"#"}>Save more on app</Link>
      </li>
      <li>
        <a href={`${MURADI_BACKOFFICE}/login`} rel="noreferrer" target="_blank">
          Sell on muradi
        </a>
      </li>
      <li>
        <Link to={"#"}>Costumer care</Link>
      </li> */}
      <li className={classes.trackorder}>
        <Link onClick={toggleTrackHandler} to={"#"}>
          Track my order
        </Link>
        {istrackShow && <OrderTracker onClick={toggleTrackHandler} />}
      </li>
      {!isLoggedIn && (
        <li>
          <Link to={"/login"}>login</Link>
        </li>
      )}
      {!isLoggedIn && (
        <li>
          <Link to={"/register"}>Signup</Link>
        </li>
      )}
      {isLoggedIn && (
        <li className={classes.account}>
          <Link onClick={toggleAccHandler} to={"#"}>
            {loggedInUsername} Account
          </Link>
          {isaccShow && (
            <TooltipMenu onClose={toggleAccHandler}>
              <div className={classes.account_popup}>
                <div>
                  <Link className={classes.account_popup_link} to={"/profile"}>
                    <ion-icon name="happy-outline"></ion-icon>
                    <div>Manage My Account</div>
                  </Link>
                </div>
                <div>
                  <Link
                    className={classes.account_popup_link}
                    to={"/profile/my_orders"}
                  >
                    <ion-icon name="cube-outline"></ion-icon>
                    <div>My Orders</div>
                  </Link>
                </div>
                <div>
                  <Link className={classes.account_popup_link} to={"#"}>
                    <ion-icon name="heart-circle-outline"></ion-icon>
                    <div>My Wishlist & Followed Stores</div>
                  </Link>
                </div>
                <div>
                  <Link className={classes.account_popup_link} to={"#"}>
                    <ion-icon name="star-outline"></ion-icon>
                    <div>My Reviews</div>
                  </Link>
                </div>
                <div>
                  <Link
                    className={classes.account_popup_link}
                    to={"/profile/order_returns"}
                  >
                    <ion-icon name="close-circle-outline"></ion-icon>
                    <div>My Returns & Cancellations</div>
                  </Link>
                </div>
                <div>
                  <div
                    onClick={logoutHandler}
                    className={classes.account_popup_link}
                  >
                    <ion-icon name="log-out-outline"></ion-icon>
                    <div>Logout</div>
                  </div>
                </div>
              </div>
            </TooltipMenu>
          )}
        </li>
      )}
      {isLoggedIn && (
        <li>
          <span onClick={logoutHandler}>Signout</span>
        </li>
      )}
      <CountrySelector onCountryChanged={logoutHandler} />
    </Fragment>
  );
};

export default SubHeaderList;
